<template>
  <Stack class="stk-p-6">
    <Buttons>
      <Button
        :to="{ name: 'ai-jobs'}"
        spacing="tight"
        icon-before="fas fa-arrow-left"
      >
        Go Back
      </Button>
    </Buttons>

    <JobForm
      :form="form"
      :loading="isSubmitting"
      @submit="handleSubmit"
    />
  </Stack>
</template>

<script setup>
import { ref } from 'vue';
import { Button, Buttons, Stack } from '@stakeui';
import { ToastProgrammatic as Toast } from 'buefy';
import { useJobsStore } from '@frontend/ui/stores/jobsStore';
import JobForm from '../components/JobForm.vue';
import { createEmptyJobForm } from '../cronUtils';

const jobsStore = useJobsStore();

const form = ref(createEmptyJobForm());

const isSubmitting = ref(false);

const handleSubmit = async ({ title, prompt, cron }) => {
  isSubmitting.value = true;

  try {
    await jobsStore.createJob(title, prompt, cron);

    Toast.open({
      message: `Job successfully created.`,
      type: 'is-success',
    });

    Object.assign(form.value, createEmptyJobForm());
  } catch {
    Toast.open({
      message: `There was an error creating the job.`,
      type: 'is-danger',
    });
  } finally {
    isSubmitting.value = false;
  }
};
</script>

